import { render, staticRenderFns } from "./sglMain.vue?vue&type=template&id=dc5f2e02&scoped=true&"
import script from "./sglMain.vue?vue&type=script&lang=js&"
export * from "./sglMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5f2e02",
  null
  
)

export default component.exports